import { useState } from 'react';

const CONTACT_INFO = [
  {
    icon: 'fa-envelope',
    title: 'ایمیل',
    value: 'info@soha-co.ir',
    description: 'پاسخگویی در کمتر از ۲۴ ساعت',
    iconColor: '#8b5cf6',
    background: '#ede9fe',
  },
  {
    icon: 'fa-phone',
    title: 'تلفن',
    value: '۱۸۱۹',
    description: 'شنبه تا پنج‌شنبه، ۸ تا ۱۶',
    iconColor: '#3b82f6',
    background: '#dbeafe',
  },
  {
    icon: 'fa-map-marker-alt',
    title: 'آدرس',
    value: 'یزد، خیابان چمران، کارخانه نوآوری درخشان',
    description: 'کد پستی: ۸۹۱۵۷۱۳۱۸۲',
    iconColor: '#10b981',
    background: '#d1fae5',
  },
  {
    icon: 'fa-clock',
    title: 'ساعات کاری',
    value: 'شنبه تا چهارشنبه: ۸:۰۰ تا ۱۶:۰۰',
    description: 'پنجشنبه: ۸:۰۰ تا ۱۴:۰۰',
    iconColor: '#f59e0b',
    background: '#fef3c7',
  },
];

export default function ContactUs() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [subject, setSubject] = useState('');
  const [message, setMessage] = useState('');

  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = (event) => {
    event.preventDefault();

    setLoading(true);

    // Replace this with the real contact API endpoint
    setTimeout(() => {
      setLoading(false);
      setSent(true);
    }, 800);
  };

  const resetForm = () => {
    setSent(false);
    setName('');
    setEmail('');
    setSubject('');
    setMessage('');
  };

  return (
    <div
      className="container contact-us-page"
      style={{
        paddingTop: '2rem',
        maxWidth: '900px',
        margin: '0 auto',
      }}
    >
      {/* Header */}
      <div
        style={{
          textAlign: 'center',
          marginBottom: '2rem',
        }}
      >
        <h1
          style={{
            fontSize: '2rem',
            fontWeight: 800,
            marginBottom: '0.5rem',
          }}
        >
          تماس با{' '}
          <span style={{ color: '#6366f1' }}>
            ایران چارسوق
          </span>
        </h1>

        <p
          style={{
            color: '#6b7280',
            fontSize: '1rem',
          }}
        >
          نظرات، پیشنهادات و سوالات خود را با ما در میان بگذارید
        </p>
      </div>

      {/* Main Content */}
      <div
        style={{
          display: 'grid',
          gridTemplateColumns:
            'repeat(auto-fit, minmax(280px, 1fr))',
          gap: '1.5rem',
        }}
      >
        {/* Contact Information */}
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '1rem',
          }}
        >
          {CONTACT_INFO.map((item) => (
            <div
              key={item.title}
              className="card"
              style={{
                padding: '1.25rem',
                display: 'flex',
                gap: '0.75rem',
                alignItems: 'flex-start',
              }}
            >
              <div
                style={{
                  width: '44px',
                  height: '44px',
                  borderRadius: '12px',
                  background: item.background,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexShrink: 0,
                }}
              >
                <i
                  className={`fas ${item.icon}`}
                  style={{
                    color: item.iconColor,
                    fontSize: '1.1rem',
                  }}
                />
              </div>

              <div>
                <h4
                  style={{
                    fontSize: '0.95rem',
                    marginBottom: '0.2rem',
                  }}
                >
                  {item.title}
                </h4>

                <p
                  style={{
                    color: '#6b7280',
                    fontSize: '0.85rem',
                  }}
                >
                  {item.value}
                </p>

                <p
                  style={{
                    color: '#9ca3af',
                    fontSize: '0.75rem',
                  }}
                >
                  {item.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Contact Form */}
        <div
          className="card"
          style={{
            padding: '1.75rem',
          }}
        >
          <h3
            style={{
              fontSize: '1.1rem',
              marginBottom: '1rem',
            }}
          >
            <i
              className="fas fa-pen"
              style={{
                marginLeft: '0.4rem',
                color: '#6366f1',
              }}
            />
            ارسال پیام
          </h3>

          {sent ? (
            <div
              style={{
                textAlign: 'center',
                padding: '2rem 0',
              }}
            >
              <i
                className="fas fa-check-circle"
                style={{
                  fontSize: '3rem',
                  color: '#10b981',
                  display: 'block',
                  marginBottom: '1rem',
                }}
              />

              <h4
                style={{
                  marginBottom: '0.5rem',
                }}
              >
                پیام شما با موفقیت ارسال شد
              </h4>

              <p
                style={{
                  color: '#6b7280',
                  fontSize: '0.85rem',
                }}
              >
                همکاران ما در اسرع وقت با شما تماس خواهند گرفت.
              </p>

              <button
                type="button"
                onClick={resetForm}
                className="btn"
                style={{
                  marginTop: '1rem',
                  background: '#e5e7eb',
                  fontSize: '0.85rem',
                }}
              >
                ارسال پیام جدید
              </button>
            </div>
          ) : (
            <form onSubmit={handleSubmit}>
              {/* Name */}
              <div
                className="form-group"
                style={{ marginBottom: '1rem' }}
              >
                <label
                  htmlFor="contact-name"
                  style={{
                    display: 'block',
                    fontWeight: 600,
                    marginBottom: '0.35rem',
                    fontSize: '0.85rem',
                  }}
                >
                  نام و نام خانوادگی
                </label>

                <input
                  id="contact-name"
                  type="text"
                  value={name}
                  onChange={(event) =>
                    setName(event.target.value)
                  }
                  required
                  placeholder="نام خود را وارد کنید"
                  style={{
                    width: '100%',
                    padding: '0.65rem 0.75rem',
                    borderRadius: '10px',
                    border: '1.5px solid #e5e7eb',
                    fontSize: '0.9rem',
                  }}
                />
              </div>

              {/* Email */}
              <div
                className="form-group"
                style={{ marginBottom: '1rem' }}
              >
                <label
                  htmlFor="contact-email"
                  style={{
                    display: 'block',
                    fontWeight: 600,
                    marginBottom: '0.35rem',
                    fontSize: '0.85rem',
                  }}
                >
                  ایمیل
                </label>

                <input
                  id="contact-email"
                  type="email"
                  value={email}
                  onChange={(event) =>
                    setEmail(event.target.value)
                  }
                  required
                  placeholder="example@email.com"
                  style={{
                    width: '100%',
                    padding: '0.65rem 0.75rem',
                    borderRadius: '10px',
                    border: '1.5px solid #e5e7eb',
                    fontSize: '0.9rem',
                  }}
                />
              </div>

              {/* Subject */}
              <div
                className="form-group"
                style={{ marginBottom: '1rem' }}
              >
                <label
                  htmlFor="contact-subject"
                  style={{
                    display: 'block',
                    fontWeight: 600,
                    marginBottom: '0.35rem',
                    fontSize: '0.85rem',
                  }}
                >
                  موضوع
                </label>

                <input
                  id="contact-subject"
                  type="text"
                  value={subject}
                  onChange={(event) =>
                    setSubject(event.target.value)
                  }
                  required
                  placeholder="موضوع پیام"
                  style={{
                    width: '100%',
                    padding: '0.65rem 0.75rem',
                    borderRadius: '10px',
                    border: '1.5px solid #e5e7eb',
                    fontSize: '0.9rem',
                  }}
                />
              </div>

              {/* Message */}
              <div
                className="form-group"
                style={{ marginBottom: '1.25rem' }}
              >
                <label
                  htmlFor="contact-message"
                  style={{
                    display: 'block',
                    fontWeight: 600,
                    marginBottom: '0.35rem',
                    fontSize: '0.85rem',
                  }}
                >
                  پیام
                </label>

                <textarea
                  id="contact-message"
                  value={message}
                  onChange={(event) =>
                    setMessage(event.target.value)
                  }
                  required
                  rows={4}
                  placeholder="پیام خود را بنویسید..."
                  style={{
                    width: '100%',
                    padding: '0.65rem 0.75rem',
                    borderRadius: '10px',
                    border: '1.5px solid #e5e7eb',
                    fontSize: '0.9rem',
                    resize: 'vertical',
                  }}
                />
              </div>

              {/* Submit */}
              <button
                type="submit"
                disabled={loading}
                className="btn btn-primary"
                style={{
                  width: '100%',
                }}
              >
                {loading ? (
                  <>
                    <i
                      className="fas fa-spinner fa-pulse"
                      style={{
                        marginLeft: '0.4rem',
                      }}
                    />
                    در حال ارسال...
                  </>
                ) : (
                  <>
                    <i
                      className="fas fa-paper-plane"
                      style={{
                        marginLeft: '0.4rem',
                      }}
                    />
                    ارسال پیام
                  </>
                )}
              </button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
